import React from 'react';

export const Hub = ({ w, h, colour, txt }) => {
  // const green = '#0ed626';
  const green = '#50ee18';
  const blue = '#008fff';
  const red = '#de4b47';
  const grey = '#777777';
  const orange = '#ffa500';

  const rgb =
    colour === 'green'
      ? green
      : colour === 'blue'
      ? blue
      : colour === 'grey'
      ? grey
      : colour === 'orange'
      ? orange
      : red;

  return (
    <React.Fragment>
      <svg
        xmlnsosb="http://www.openswatchbook.org/uri/2009/osb"
        xmlnsdc="http://purl.org/dc/elements/1.1/"
        xmlnscc="http://creativecommons.org/ns#"
        xmlnsrdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlnssvg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlnssodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlnsinkscape="http://www.inkscape.org/namespaces/inkscape"
        width={w}
        height={h}
        viewBox="0 0 16.933333 16.933334"
        version="1.1"
        id="svg8"
        inkscapeversion="0.92.2 5c3e80d, 2017-08-06"
        sodipodidocname="charger.svg"
      >
        <defs id="defs2">
          <linearGradient id="linearGradient12297" osbpaint="solid">
            <stop
              style={{ stopColor: '#000000', stopOpacity: 1 }}
              offset="0"
              id="stop12295"
            />
          </linearGradient>
        </defs>
        <sodipodiNamedview
          id="base"
          pagecolor="#ffffff"
          bordercolor="#666666"
          borderopacity="1.0"
          inkscapepageopacity="0.0"
          inkscapepageshadow="2"
          inkscapezoom="14.414829"
          inkscapecx="32.044152"
          inkscapecy="29.171318"
          inkscapedocument-units="mm"
          inkscapecurrent-layer="layer1"
          showgrid="false"
          units="px"
          inkscapeshowpageshadow="false"
          inkscapewindow-width="3840"
          inkscapewindow-height="2099"
          inkscapewindow-x="0"
          inkscapewindow-y="0"
          inkscapewindow-maximized="1"
        />
        <metadata id="metadata5">
          <rdfrDF>
            <ccWork rdfabout="">
              <dcFormat>image/svg+xml</dcFormat>
              <dcType rdfresource="http://purl.org/dc/dcmitype/StillImage" />
              <dcTitle></dcTitle>
            </ccWork>
          </rdfrDF>
        </metadata>
        <g
          inkscapelabel="Layer 1"
          inkscapegroupmode="layer"
          id="layer1"
          transform="translate(0,-280.06665)"
        >
          <path
            style={{
              opacity: 0.5,
              fill: rgb,
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 0.46609831,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 4,
              strokeDasharray: 'none',
              strokeDashoffset: 0,
              strokeOpacity: 1,
              paintOrder: 'normal'
            }}
            id="SymbolBackground"
            sodipoditype="arc"
            sodipodicx="8.4436836"
            sodipodicy="288.53629"
            sodipodirx="8.4788866"
            sodipodiry="8.4704943"
            sodipodistart="4.7142216"
            sodipodiend="4.7090204"
            d="m 8.4592222,280.06581 a 8.4788866,8.4704943 0 0 1 8.4633468,8.47498 8.4788866,8.4704943 0 0 1 -8.4723738,8.46599 8.4788866,8.4704943 0 0 1 -8.48538004,-8.45298 8.4788866,8.4704943 0 0 1 8.45030674,-8.48796"
            sodipodiopen="true"
          />
          <text
            xmlSpace="preserve"
            style={{
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '6.58706141px',
              lineHeight: 1.25,
              fontFamily: 'sans-serif',
              letterSpacing: '0px',
              wordSpacing: '0px',
              fill: '#000000',
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 0.08967653
            }}
            id="HubInfo1"
            transform="scale(0.99700004,1.003009)"
          >
            <tspan
              sodipodirole="line"
              id="tspan13735"
              x="50%"
              y="289.8"
              textAnchor="middle"
              style={{
                strokeWidth: 0.08967653
              }}
            >
              {txt}
            </tspan>
          </text>
        </g>
        <style
          id="style12273"
          type="text/css"
        >{`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}</style>
      </svg>
    </React.Fragment>
  );
};
